import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";


export const fetchAcadamicHistory = createAsyncThunk(
  "studentHistort/fetchStudentHistory",
  async (studentId) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      const userData = storedUser ? JSON.parse(storedUser) : null;
      const storedToken = localStorage.getItem("token");
       if (!userData || !storedToken) {
        throw new Error("No user data or token found");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/StudentHistory/Student/${studentId}`,
        {
          headers: { Authorization: `Bearer ${storedToken}` },
        }
      );
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch student History : ${errorText}`);
      }
      const data = await response.json();
 //     console.log("123-----------------data", data);
      return Array.isArray(data) ? data : [data]; // Adjusting to always return an array
    } catch (error) {
      console.error("Error fetching  student History:", error);
      throw error;
    }
  }
);
export const fetchAllAcadamicHistory = createAsyncThunk(
  "HealthIssue/fetchAllStudentHealthIssues",
  async (_, { dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      const userData = storedUser ? JSON.parse(storedUser) : null;
      const storedToken = localStorage.getItem("token");
      if (!userData || !storedToken) {
        throw new Error("No user data or token found");
      }

      const allAcademicHistory = [];
      for (const studentId of userData.studentIds) {
        // Await the response and store it in a variable
        const response = await dispatch(
          fetchAcadamicHistory(studentId)
        ).unwrap(); // Use unwrap to handle the payload directly
        // Ensure response is an array and spread into allAcademicHistory
        if (Array.isArray(response)) {
          allAcademicHistory.push(...response);
        } else {
          console.warn(
            `Expected an array for studentId ${studentId}, but received:`,
            response
          );
        }
      }
//      console.log("123-----------------allAcademicHistory", allAcademicHistory);

      return allAcademicHistory; // Return all health issues
    } catch (error) {
      console.error("Error fetching allacademic history:", error);
      throw error; // Rethrow the error for Redux to handle it
    }
  }
);

export const createStudentHistory = createAsyncThunk(
  "studentHistory/createStudentHistory",
  async (
    { studentId, base64Strings, schoolData },
    { rejectWithValue }
  ) => {
    try {
      const dataToSubmit = {
        schoolName: schoolData.schoolName,
        gradeFrom: parseInt(schoolData.gradeFrom, 10), // Convert to integer
        gradeTo: parseInt(schoolData.gradeTo, 10), // Convert to integer
        entryDate: schoolData.entryDate,
        exitDate: schoolData.exitDate,
        schoolPhoneNumber: schoolData.schoolPhoneNumber,
        schoolAddress: schoolData.schoolAddress,
        document: base64Strings.document,
        studentId: studentId,
      };

      console.log("dataToSubmit", dataToSubmit);
       const storedToken = localStorage.getItem("token");
      console.log("storedToken", storedToken);
      const response = await fetch(
        `${API_BASE_URL}/api/StudentHistory/Create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storedToken}`,
          },
          body: JSON.stringify(dataToSubmit),
        }
      );
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to create student history: ${errorText}`);
      }

      const data = await response.json();
      return data; // Return the relevant response
    } catch (error) {
      return rejectWithValue("Error creating health issue:", error);
    }
  }
);
export const updateStudentHistory = createAsyncThunk(
  "healthInfo/updateHealthInfo",
  async (
    { studentId, studentHistoryId, base64Strings, schoolData },
    rejectWithValue
  ) => {
    try {
     const dataToSubmit = {
  historyDto: {
    schoolName: schoolData.schoolName,
    gradeFrom: parseInt(schoolData.gradeFrom, 10),
    gradeTo: parseInt(schoolData.gradeTo, 10),
    entryDate: schoolData.entryDate?.toISOString?.() || new Date().toISOString(),
    exitDate: schoolData.exitDate?.toISOString?.() || new Date().toISOString(),
    schoolPhoneNumber: schoolData.schoolPhoneNumber,
    schoolAddress: schoolData.schoolAddress,
    document: base64Strings.document,
    studentId: studentId,
    studentHistoryId: studentHistoryId,
  }
};

      const storedToken = localStorage.getItem("token");
 //     console.log("dataToSubmit", dataToSubmit);

      if (!storedToken) {
        return rejectWithValue("No authorization token found");
      }
      console.log("JSON.stringify(dataToSubmit)", JSON.stringify(dataToSubmit));
      console.log("storedToken", storedToken);
      console.log("path", `${API_BASE_URL}/api/StudentHistory/Update`);
      const response = await fetch(
        `${API_BASE_URL}/api/StudentHistory/Update`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storedToken}`,
          },
          body: JSON.stringify(dataToSubmit),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        return rejectWithValue(`Failed to update health info: ${errorText}`);
      }
      const data = await response.json();
      return data; // Return the updated health information
    } catch (error) {
      return rejectWithValue("Error updating health info:", error);
    }
  }
);

const studentHistorySlice = createSlice({
  name: "studentHistory",
  initialState: {
    studentHistoyList: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAcadamicHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllAcadamicHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.studentHistoyList = action.payload; // Update with all students' issues
      })
      .addCase(fetchAllAcadamicHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const studentHistorySelector = (state) => state.studentHistory;

export default studentHistorySlice.reducer;
